module.exports = {"371426001":"龙门街道","371426002":"桃园街道","371426003":"德原街道","371426101":"王凤楼镇","371426102":"前曹镇","371426103":"恩城镇","371426104":"王庙镇","371426105":"王杲铺镇","371426106":"张华镇","371426107":"腰站镇","371426108":"王打卦镇","371426202":"三唐乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/371426.json
// module id = 1596
// module chunks = 0